import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { getCommandsEchouee } from '@/api/commandes.api'
import { APP_NAME, validateCommandsPageSearchParams } from '@/lib/utils'
import CommandsEchouee from '@/features/commands/components/extensions/commands-echouee'

export const Route = createFileRoute('/_authenticated/commands-echoue/')({
  component: () => {
    const { t } = useTranslation()
    return (
      <CommandsEchouee
        queryExtension={{
          title: t('sidebar.commandes-echouees'),
          querykey: 'echouee',
          queryFn: getCommandsEchouee,
        }}
      />
    )
  },
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Commandes échouées`,
      },
    ],
  }),
  validateSearch: validateCommandsPageSearchParams,
})
